import { render, staticRenderFns } from "./TrainingOfflineDetail.vue?vue&type=template&id=2b7ad58e&scoped=true"
import script from "./TrainingOfflineDetail.vue?vue&type=script&lang=js"
export * from "./TrainingOfflineDetail.vue?vue&type=script&lang=js"
import style0 from "./TrainingOfflineDetail.vue?vue&type=style&index=0&id=2b7ad58e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7ad58e",
  null
  
)

export default component.exports